import { BadgeType } from 'interfaces/dealer-opinions.interface';
import React from 'react';

/* eslint-disable max-len */

interface OpineoShieldProps {
    dealerBadge?: {
        name: string;
        type: BadgeType;
    };
    className?: string;
}

const OpineoShield: React.FC<OpineoShieldProps> = ({ dealerBadge, className }) => {
    let color = '#0C6FF9';

    switch (dealerBadge?.type) {
        case 'BASIC': {
            color = '#0C6FF9';
            break;
        }
        case 'SILVER': {
            color = 'silver';
            break;
        }
        case 'GOLD': {
            color = 'gold';
            break;
        }
        case 'PLATINUM': {
            color = 'skyblue';
            break;
        }
    }

    return <span className={className}>
        <svg width="22" height="26" viewBox="0 0 22 26"
            fill="none" xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="22" height="26" fill="transparent" />
            <rect width="1024" height="8324" transform="translate(-648 -1235)"
                fill="transparent"
            />
            <rect width="920" height="542" transform="translate(-597 -276)"
                fill="transparent"
            />
            <rect x="-573" y="-40" width="872"
                height="138" rx="2" fill="transparent"
            />
            <path d="M6 12H8V17H6V12Z" fill={color} />
            <path d="M16.72 2.51613C13.7366 1.67742 11 0 11 0C11 0 8.26336 1.67742 5.28 2.51613C2.45426 3.31054 0 3.35484 0 3.35484V14.2965C1.56957e-06 15.8276 0.404237 17.3341 1.17547 18.6772C1.94671 20.0203 3.06016 21.1569 4.41325 21.9823L11 26L17.5867 21.9823C18.9399 21.1569 20.0533 20.0204 20.8245 18.6772C21.5958 17.3341 22 15.8276 22 14.2965V3.35484C22 3.35484 19.5457 3.31054 16.72 2.51613ZM20.24 14.2965C20.2431 15.5467 19.9145 16.7774 19.2848 17.8741C18.655 18.9708 17.7446 19.898 16.638 20.5694L11 24.0084L5.362 20.5694C4.25545 19.898 3.34497 18.9708 2.71522 17.8741C2.08546 16.7774 1.75687 15.5467 1.76 14.2965V4.90226C3.1196 4.74984 4.46354 4.48987 5.77791 4.12504C7.8997 3.5285 9.878 2.55681 11 1.95157C12.122 2.55681 14.1003 3.5285 16.222 4.12504C17.5364 4.48986 18.8804 4.74983 20.24 4.90226V14.2965Z" fill={color} />
            <path d="M15.7589 5.80743C13.9297 5.32621 12.2211 4.59359 11 4C9.77895 4.59359 8.07027 5.32621 6.24101 5.80743C5.17811 6.08388 4.09525 6.29519 3.00002 6.43988V14.1951C2.99736 15.1885 3.27639 16.1665 3.81116 17.0379C4.34593 17.9094 5.11909 18.6461 6.05875 19.1796L11 22L15.9413 19.1796C16.8809 18.6461 17.6541 17.9094 18.1888 17.0379C18.7236 16.1665 19.0026 15.1885 19 14.1951V6.43988C17.9047 6.29518 16.8219 6.08387 15.7589 5.80743Z" fill={color} />
            <path d="M6 14.515C6.71499 14.9275 7.38727 15.4055 8.00756 15.9425C8.69651 16.5786 9.33216 17.2666 9.90851 18C9.90851 18 11.4509 16.0713 12.9281 14.5952C13.8948 13.6419 14.9207 12.7463 16 11.9135V8C16 8 13.8538 9.60062 12.6066 11.3001C11.6474 12.6833 10.7737 14.1202 9.99015 15.6033C9.72105 15.0504 9.39942 14.5228 9.02938 14.0275C8.72455 13.6327 8.38988 13.2603 8.02813 12.9134C7.26983 13.3418 6.58551 13.8822 6 14.515V14.515Z" fill="white" />
        </svg>
        <span className="text" style={{ color }}>{dealerBadge?.name} Opineo</span>
    </span >;
};

export default OpineoShield;
